var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".info_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__cls-1",
    d: "M15 3.5C8.65 3.5 3.5 8.65 3.5 15S8.65 26.5 15 26.5 26.5 21.35 26.5 15 21.35 3.5 15 3.5ZM1.5 15C1.5 7.54 7.54 1.5 15 1.5S28.5 7.54 28.5 15 22.46 28.5 15 28.5 1.5 22.46 1.5 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__cls-1",
    d: "M15 14c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1s-1-.45-1-1v-5c0-.55.45-1 1-1ZM14 10c0-.55.45-1 1-1h.01c.55 0 1 .45 1 1s-.45 1-1 1H15c-.55 0-1-.45-1-1Z"
  })));
};

export default SvgInfo;